import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import { Grid } from "@material-ui/core";
import axiosConfig from "../../axiosConfig";
import numberFormat from "../numberFormat";

const useStyles = makeStyles({
  root: {
    minWidth: 275,
    marginTop: "3%",
    marginBottom: "3%",
  },
  planRoot: {
    minWidth: 275,
    borderColor: "#F6277F",
    borderWidth: 1,
    border: "solid",
    boxShadow: 0,
  },
  planNoRoot: {
    minWidth: 275,
    borderColor: "#e0e0e0",
    borderWidth: 1,
    border: "solid",
    boxShadow: 0,
  },
  bullet: {
    display: "inline-block",
    margin: "0 2px",
    transform: "scale(0.8)",
  },
  cardTitle: {
    fontSize: 20,
    color: "#F6277F",
    fontFamily: "Open Sans",
    fontWeight: "700",
    marginBottom: 24,
    textAlign: "center",
  },
  planTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#ababab",
    textAlign: "center",
    fontFamily: "Open Sans",
  },
  priceTitle: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#F6277F",
    textAlign: "center",
    fontFamily: "Open Sans",
  },
  priceSubTitle: {
    fontSize: 14,
    fontWeight: "bold",
    color: "#ababab",
    textAlign: "center",
    fontFamily: "Open Sans",
  },
  selectButton: {
    backgroundColor: "#F6277F",
    color: "#FFF",
    fontSize: 14,
    fontWeight: "500",
    fontFamily: "Open Sans",
    textTransform: "none",
    border: "solid",
    borderColor: "#F6277F",
    borderWidth: 1,
  },
  unselectButton: {
    backgroundColor: "#FFF",
    color: "#F6277F",
    fontSize: 14,
    fontWeight: "500",
    fontFamily: "Open Sans",
    textTransform: "none",
    border: "solid",
    borderColor: "#F6277F",
    borderWidth: 1,
  },
});

export default function SimpleCard(props) {
  const [planData, setPlanData] = useState([]);
  const [selected, setSelected] = useState();
  const classes = useStyles();

  useEffect(() => {
    const fetchData = async () => {
      axiosConfig
        .get("/brand/stripe/plans")
        .then((res) => {
          // console.log("pK ", res);
          setPlanData(res.data.plans);
          setSelected(res.data.plans[0]);
          props.updatePlan(res.data.plans[0]);
        })
        .catch((error) => {
          // console.log("Error in api ", error);
          // console.log("Error in api ", error.response);
        });
    };
    fetchData();
  }, []);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  function selectPlan(plans) {
    props.updatePlan(plans);
    setSelected(plans);
  }

  function CardComponent(props) {
    const { plans } = props;
    // console.log("PLAN HERE", plans);
    return (
      <Grid item xs={12} md={5}>
        <Card className={classes.planRoot} elevation={0}>
          <CardContent>
            <Typography className={classes.planTitle}>
              {plans.nickname}
            </Typography>
            <Typography className={classes.priceTitle}>{`$${numberFormat(
              plans.amount / 100
            )} CAD`}</Typography>
            <Typography className={classes.priceSubTitle}>
              Per {`${capitalizeFirstLetter(plans.interval)}`}
              <br />
              Billed{" "}
              {`${
                capitalizeFirstLetter(plans.interval) === "Year"
                  ? "Annual"
                  : "Month"
              }ly`}
            </Typography>
          </CardContent>
          <CardActions>
            <Grid container alignItems="center" justify="center">
              <Button
                className={
                  selected === plans
                    ? classes.selectButton
                    : classes.unselectButton
                }
                onClick={() => selectPlan(plans)}
              >
                {selected === plans ? "Selected" : "Select"}
              </Button>
            </Grid>
          </CardActions>
        </Card>
      </Grid>
    );
  }

  return (
    <Grid className={classes.root}>
      <Typography className={classes.cardTitle}>Subscribe to a plan</Typography>
      <Grid container spacing={2} alignItems="center" justify="center">
        {planData.map((plan, index) => (
          <CardComponent plans={plan} key={index} />
        ))}
      </Grid>
    </Grid>
  );
}
